import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { getFormattedAmount } from '@shared/utils';

@Component({
  selector: 'app-limit-edit-item-field',
  templateUrl: './limit-edit-item-field.component.html',
  imports: [FormsModule, ReactiveFormsModule, NgxMaskDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [provideNgxMask()],
})
export class LimitEditItemFieldComponent implements OnInit, OnChanges {
  @Input() initialValue?: number;

  @Input() maxAmountValue = 999999999;

  @Input() limitType = '';

  @Input() maxLimitLabel?: string;

  @Input() currentValue?: number | null;

  public isMaximumValue = false;

  public isMinimumValue = false;

  public isSameValue = false;

  public valueField = new UntypedFormControl();

  public maxLimitsType: Record<string, string> = {
    single: '1 day limit',
    daily: '7 days limit',
    weekly: '30 days limit',
    monthly: '999999999',
  };

  @Output() changed = new EventEmitter<string>();

  @Output() errored = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.updateFieldValue(this.initialValue);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.initialValue && changes.hasOwnProperty('maxAmountValue')) {
      this.isMaximumValue = this.initialValue > this.maxAmountValue;
      this.isMinimumValue = this.initialValue < 0;
      this.isSameValue = this.currentValue !== undefined && this.currentValue !== null && this.initialValue === this.currentValue;
      this.errored.emit(this.isMaximumValue || this.isMinimumValue || this.isSameValue);
    }
  }

  updateFieldValue(value?: number): void {
    if (value === undefined || value === null) {
      return;
    }

    const formattedValue = getFormattedAmount(parseFloat(`${this.initialValue}`)).formattedValue;
    this.setValue(formattedValue);
    this.changed.emit(formattedValue);
  }

  onBlur(): void {
    const fieldValue = this.valueField.value;
    if (fieldValue === '' || fieldValue === null || fieldValue === undefined) {
      this.valueField.reset();
    } else {
      const value = parseFloat(fieldValue);
      if (!isNaN(value)) {
        this.valueField.setValue(getFormattedAmount(value).formattedValue);
      }
    }
  }

  onChange(value: string): void {
    if (this.valueField.dirty) {
      const parsedValue = parseFloat(value);
      this.isMaximumValue = parsedValue > this.maxAmountValue;
      this.isMinimumValue = value !== '' && parsedValue < 0;
      this.isSameValue =
        this.currentValue !== undefined && this.currentValue !== null && !isNaN(parsedValue) && parsedValue === this.currentValue;
    }

    this.changed.emit(value);
    this.errored.emit(this.isMaximumValue || this.isMinimumValue || this.isSameValue);
  }

  resetValue(): void {
    this.valueField.reset();
    this.errored.emit(false);
  }

  setValue(value?: string): void {
    this.valueField.setValue(value);
  }

  isDirty(): boolean {
    return this.valueField.dirty;
  }
}
